module.exports = __webpack_public_path__ + "static/media/assicurazioni-logo.85ee354b.svg";